module.exports = __webpack_public_path__ + "img/Success_TruckDelivery@2x.f52943cc.png";